import type {MemexColumnDataType} from '../../../api/columns/contracts/memex-column'
import {BaseColumnModel} from '../abstract/base'

export class DateColumnModel extends BaseColumnModel {
  declare readonly id: number
  declare readonly dataType: typeof MemexColumnDataType.Date
  declare readonly userDefined: true
}
